import { OverpaymentManagementError } from '../types';

export const defaultIbanError: OverpaymentManagementError = {
    iban: { invalidFormat: 'Wrong IBAN format' },
};
